<h1 mat-dialog-title>Choose a resource from library</h1>
<div mat-dialog-content>
  <app-media-grid
    [equipment]="data.equipment"
    [paginator]="paginator"
    [resources]="resources"
    [cols]="3"
    fixDimension="columns"
    [containerHeight]="600"
    [selectable]="true"
    [uploadableResources]="data.types"
    [viewableResources]="data.types"
    (onResourceSelected)="onResourceSelected($event)"
  ></app-media-grid>
</div>
<div mat-dialog-actions class="actions">
  <div>
    <button mat-stroked-button (click)="onNoClick()">{{ 'Cancel' | translate }}</button>
    <button mat-flat-button color="primary" (click)="onChooseCompleted(data)" cdkFocusInitial [disabled]="!data.resource">Choose resource</button>
  </div>
</div>
